import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Header from '../Type/Header';

import './LargeLink.module.css';

class LargeLink extends PureComponent {
  render() {
    const { title, url, copy } = this.props;
    return (
      <div styleName="large-link">
        <Link to={url}>
          <div styleName="large-link-header">
            <Header level={5} displayAs={5}>
              {title}
            </Header>
            <Header level={5} displayAs={5} styles={{ color: '#4c93eb' }}>
              →
            </Header>
          </div>
          <p styleName="large-link-copy">{copy}</p>
        </Link>
      </div>
    );
  }
}
LargeLink.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  copy: PropTypes.string
};

export default LargeLink;
